import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.div`
  width: 100%;
  height: 55px;
  display: flex;
  & > button {
    font-size: 18px;
    font-weight: 400;
    padding: 0;
  }

  @media screen and (min-width: ${DESKTOP}px) {
    width: 229px;
    height: 79px;

    & > button {
      font-size: 24px;
    }
  }
`;
